import styled, { css } from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';

export const inputCss = css`
  .ant-input-affix-wrapper {
    ${media.down('sm')} {
      padding: 13px 20px;
    }
    border-radius: 12px;
    border: 1px solid ${vars.quantumverse.reskinColors.neutral200};
    background: ${vars.quantumverse.reskinColors.white};
    font-family: Rubik;
    &.ant-input-affix-wrapper-focused {
      border-color: ${vars.quantumverse.reskinColors.purple500};
      box-shadow: 0px 0px 0px 2px #c3b6fb;
    }
    .ant-input-prefix {
      margin-right: 10px;
    }

    input {
      font-size: ${pxToRem(15)};
      text-align: left;
      color: ${vars.quantumverse.reskinColors.neutral700};
      &:focus {
        outline: none;
        text-overflow: clip;
      }
      &::placeholder {
        color: ${vars.quantumverse.reskinColors.neutral300};
        opacity: 1;
      }
    }
  }
`;

export const Styled = styled.div`
  .ant-input-search {
    /* Hide default search button */
    &.-noAddonAfter,
    &.-noEnterButton {
      .ant-input-affix-wrapper {
        border-radius: ${vars.defaultBorderRadius};
      }
    }
    &.-noAddonAfter.-noEnterButton {
      .ant-input-group-addon:last-child {
        display: none;
      }
    }
    &.-noEnterButton {
      .ant-input-group-addon {
        > button:first-child {
          display: none;
        }
      }
    }

    &.-addonBefore {
      .ant-input-group-addon:first-child {
        background: none;
      }
      .ant-input-affix-wrapper {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    ${inputCss}
  }
`;
